import { useEffect, useRef } from "react";

const DEFAULT_INTERVAL_MS = 30000;

// Polls at a fixed interval and invokes onTick, so dashboards can refetch periodically.
// Pauses while the tab isn't visible, so backgrounded dashboards stop generating load.
export default function usePollingInterval(onTick, intervalMs = DEFAULT_INTERVAL_MS) {
  const onTickRef = useRef(onTick);
  onTickRef.current = onTick;

  useEffect(() => {
    let id;

    const start = () => {
      if (id) return;
      id = setInterval(() => onTickRef.current(), intervalMs);
    };
    const stop = () => {
      clearInterval(id);
      id = undefined;
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') start();
      else stop();
    };

    if (document.visibilityState === 'visible') start();
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      stop();
    };
  }, [intervalMs]);
}
